import React, { FC, useState, useEffect } from 'react';
import axios from 'axios';

import { UserPage } from 'components/UserPage';
import { Section } from 'components/Section';
import { BreadCrumbs } from 'components/BreadCrumbs';


type Props = {};


export const MyListPage: FC<Props> = () => {
    const [spotList, setSpotList] = useState<Spots>([]);

    useEffect(() => {
        async function initialize() {
            const { data: { spots } } = await axios.get(
                `${window.location.origin}/api/map/my_list/`
            );
            setSpotList(spots ?? []);
        };
        initialize();
    }, []);

    return (
        <UserPage title="Salon.jp | お店の管理" disableBackButton>
            <Section fillOnSp>
                <div className="wrapper">
                    <div className="bread-crumbs-wrapper">
                        <BreadCrumbs items={[
                            {
                                title: 'お店の一覧',
                                href: '/map/my_list',
                            },
                        ]} />
                    </div>
                    <h1 className="title">お店一覧</h1>
                    <div className="spot-list">
                        {spotList.map((spot, i) => (
                            <a
                                className="spot"
                                key={`spot-${i}`}
                                href={`/map/spot/${spot.id}/admin`}
                            >
                                <img src={spot.coverImage} />
                                <span>{spot.name}</span>
                                <img src="/img/menu/icon-menu-arrow.png" />
                            </a>
                        ))}
                    </div>
                </div>
            </Section>

            <style jsx>{`
                .wrapper {
                    height: calc(${window.innerHeight}px - 45px - 45px);
                    padding-top: 10px;
                }
                .bread-crumbs-wrapper {
                    padding-bottom: 20px;
                }
                .title {
                    font-weight: normal;
                    font-size: 20px;
                    margin-left: 20px;
                }
                .spot-list {
                    display: block;
                    font-size: 15pt;
                }
                .spot-list > a {
                    display: flex;
                    align-items: center;
                    padding: 8px 5px;
                    height: 80px;
                    border-top: 1px solid silver;
                    text-decoration: none;
                    color: #2b2b2b;
                }
                .spot-list > a:nth-last-child(1) {
                    border-bottom: 1px solid silver;
                }
                .spot-list > a > span {
                    flex-grow: 1;
                }
                .spot-list > a > img {
                    width: 30px;
                }
                .spot-list > a > img:first-of-type {
                    width: 100px;
                    height: 100%;
                    margin-right: 20px;
                }
                @media screen and (max-width: 540px) {
                    .spot-list {
                        font-size: 13pt;
                    }
                }
            `}</style>
        </UserPage>
    );
};
